import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Edit from "@material-ui/icons/EditOutlined";
import { maybe } from "@saleor/misc";
import { failedReasonsNationwideDelivery } from "@saleor/motherOrders/utils/handlers";
import {
  DeliveriesStatus,
  DeliveryTypeEnum,
  SmopOrderStatusEnum
} from "@saleor/types/globalTypes";
import * as React from "react";

interface RiderCellProps {
  order: any;
  onAssignRider: (orderId: string, orderCode: string, mallId?: string) => void;
}

const useStyles = makeStyles(
  () => ({
    riderCellContent: {
      display: "flex",
      flex: "none",
      flexDirection: "column",
      fontSize: "11px",
      width: "10em"
    },
    riderCellContentText: {
      display: "flex",
      flex: "none",
      flexDirection: "column",
      width: "10em"
    },
    riderName: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  }),
  { name: "RiderCell" }
);

const RiderCell: React.FC<RiderCellProps> = props => {
  const { order, onAssignRider } = props;
  const classes = useStyles(props);

  const [isOverflowed, setIsOverflow] = React.useState(false);

  const textElementRef = React.useRef<HTMLDivElement>();
  React.useEffect(() => {
    if (textElementRef.current) {
      setIsOverflow(
        textElementRef?.current.scrollWidth >
          textElementRef?.current?.clientWidth
      );
    }
  }, []);

  return (
    <>
      {((maybe(() => order.shippingMethod.deliveryType) ===
        DeliveryTypeEnum.EXPRESS ||
        maybe(() => order.shippingMethod.deliveryType) ===
          DeliveryTypeEnum.SAME_DAY ||
        maybe(() => order.shippingMethod.deliveryType) ===
          DeliveryTypeEnum.EXPRESS_LONG_DISTANCE) &&
        order.smopStatus !== SmopOrderStatusEnum.COMPLETED &&
        order.smopStatus !== SmopOrderStatusEnum.CANCELED) ||
      (maybe(() => order.shippingMethod.deliveryType) ===
        DeliveryTypeEnum.NEXT_DAY &&
        order.smopStatus === SmopOrderStatusEnum.READY_TO_SHIP) ||
      (maybe(() => order.shippingMethod.deliveryType) ===
        DeliveryTypeEnum.NEXT_DAY &&
        order.smopStatus === SmopOrderStatusEnum.NEW_ORDER) ||
      maybe(() =>
        failedReasonsNationwideDelivery(order?.deliveryCourier?.failedReason)
      ) ||
      maybe(
        () =>
          [DeliveriesStatus.GRAB_PICKING_UP].includes(
            order?.thirdPartyRider?.deliveryCourier.status
          ),
        false
      ) ? (
        <Button
          id="btnAdminFulfillmentAssignRiderCell"
          variant="outlined"
          endIcon={<Edit />}
          onClick={() =>
            onAssignRider(order.id, order.orderCode, order?.mall?.id)
          }
        >
          {maybe(() => order.rider) ||
          (maybe(() => order.thirdPartyRider) &&
            order?.thirdPartyRider?.deliveryCourier?.status !== "GRAB_FAILED" &&
            order?.thirdPartyRider?.deliveryCourier?.status !==
              "GRAB_CANCELED" &&
            order?.thirdPartyRider?.deliveryCourier?.status !==
              "GRAB_RETURNED" &&
            order?.thirdPartyRider?.deliveryCourier?.status !==
              "GRAB_USER_CANCELED" &&
            order?.thirdPartyRider?.deliveryCourier?.status !==
              "PANDAGO_USER_CANCELLED" &&
            order?.thirdPartyRider?.deliveryCourier?.status !==
              "PANDAGO_CANCELLED") ? (
            <div>
              {maybe(() => order.isRider3pl) ? (
                <div
                  id="cmpAdminFulfillmentRiderCellContent"
                  className={classes.riderCellContent}
                >
                  {order?.thirdPartyRider.firstName ? (
                    <span
                      id="txtAdminFulfillmentRiderCellContentRiderName"
                      className={classes.riderName}
                    >{`${
                      order?.thirdPartyRider.firstName === null
                        ? order?.courier
                        : maybe(() => order?.thirdPartyRider?.firstName, "-")
                    } ${
                      order?.thirdPartyRider.lastName === null
                        ? ""
                        : maybe(() => order?.thirdPartyRider?.lastName, "")
                    }`}</span>
                  ) : (
                    <span
                      id="txtAdminFulfillmentRiderCellContentCourierName"
                      style={{ color: "#00000080" }}
                    >
                      {order?.courier}
                    </span>
                  )}

                  <span id="txtAdminFulfillmentRiderCellContentRiderContactNo">
                    {order?.thirdPartyRider?.contactNo}
                  </span>
                </div>
              ) : (
                <div
                  id="cmpAdminFulfillmentRiderCellContent"
                  className={classes.riderCellContent}
                >
                  <span
                    id="txtAdminFulfillmentRiderCellContentRiderName"
                    className={classes.riderName}
                  >{`${order?.rider?.firstName} ${order?.rider?.lastName}`}</span>
                  <span id="txtAdminFulfillmentRiderCellContentRiderContactNo">
                    {order?.rider?.contactNo}
                  </span>
                </div>
              )}
            </div>
          ) : (
            <div
              id="cmpAdminFulfillmentRiderCellContent"
              className={classes.riderCellContent}
            >
              <span id="txtAdminFulfillmentRiderCellAssign">Assign</span>
            </div>
          )}
        </Button>
      ) : (
        <div
          id="cmpAdminFulfillmentRiderCellContentText"
          className={classes.riderCellContentText}
        >
          {order?.rider || order?.thirdPartyRider ? (
            <>
              {maybe(() => order.isRider3pl) ? (
                <>
                  <Tooltip
                    id="cmpAdminFulfillmentRiderCellContextTooltip"
                    placement="top"
                    title={`${order?.thirdPartyRider?.firstName} ${order?.thirdPartyRider?.lastName}`}
                    disableHoverListener={!isOverflowed}
                    interactive
                  >
                    <div
                      id="cmpAdminFulfillmentRiderCellContextRiderDetails"
                      className={classes.riderName}
                      ref={textElementRef}
                    >
                      <span
                        id="txtAdminFulfillmentRiderCellContextRiderName"
                        className={classes.riderName}
                      >{`${
                        order?.thirdPartyRider.firstName === null
                          ? "--"
                          : maybe(() => order?.thirdPartyRider?.firstName, "-")
                      } ${
                        order?.thirdPartyRider.lastName === null
                          ? ""
                          : maybe(() => order?.thirdPartyRider?.lastName, "")
                      }`}</span>
                    </div>
                  </Tooltip>
                  <span id="txtAdminFulfilmentRiderCellContextRiderContactNo">
                    {order?.thirdPartyRider?.contactNo}
                  </span>
                </>
              ) : (
                <>
                  <Tooltip
                    id="cmpAdminFulfillmentRiderCellContextTooltip"
                    placement="top"
                    title={`${order?.rider.firstName} ${order?.rider.lastName}`}
                    disableHoverListener={!isOverflowed}
                    interactive
                  >
                    <div
                      id="cmpAdminFulfillmentRiderCellContextRiderDetails"
                      className={classes.riderName}
                      ref={textElementRef}
                    >
                      <span
                        id="txtAdminFulfillmentRiderCellContextRiderName"
                        className={classes.riderName}
                      >{`${order?.rider?.firstName} ${order?.rider?.lastName}`}</span>
                    </div>
                  </Tooltip>
                  <span id="txtAdminFulfilmentRiderCellContextRiderContactNo">
                    {order?.rider?.contactNo}
                  </span>
                </>
              )}
            </>
          ) : (
            "--"
          )}
        </div>
      )}
    </>
  );
};

export default RiderCell;
